'use strict';

import React from 'react';
import { renderComponent } from '@src/utils/renderer/client-renderer';
import { createStoreFrontStore } from '../../redux/store';
import { StoreFrontPage } from '../../views/storefront/main';

if (window.APP === 'merchant-storefront') {
    const store = createStoreFrontStore(window.REDUX_DATA);

    renderComponent(<StoreFrontPage />, {
        store,
        enableQueryClient: false,
        useHydrateRoot: true
    });
}
